import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiOnboardingAssigneesBannerComponent } from './fi-onboarding-assignees-banner/fi-onboarding-assignees-banner.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiOnboardingSynchronizedService } from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-synchronized.service';
import { UIRouterModule } from '@uirouter/angular';
import { OnboardingSynchronizedStates } from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-synchronized-states';
import { FiOnboardingAssignUsersComponent } from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-assign-users/fi-onboarding-assign-users.component';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiOnboardingProgressBarModule } from '@fi-app/fi-onboarding/fi-onboarding-progress-bar/fi-onboarding-progress-bar.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { FiOnboardingMasterUserAssigneesComponent } from '@fi-app/fi-onboarding/fi-onboarding-synchronized/fi-onboarding-master-user-assignees/fi-onboarding-master-user-assignees.component';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        UIRouterModule.forChild(OnboardingSynchronizedStates),
        FiProfileIconModule,
        SelectSearchModule,
        FiOnboardingProgressBarModule,
        FiWrapperTableModule,
        MatSortModule,
        MatTableModule,
    ],
    declarations: [
        FiOnboardingAssigneesBannerComponent,
        FiOnboardingAssignUsersComponent,
        FiOnboardingMasterUserAssigneesComponent,
    ],
    providers: [FiOnboardingSynchronizedService],
    exports: [FiOnboardingAssigneesBannerComponent],
})
export class FiOnboardingSynchronizedModule {}
